import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';

export const surveyServiceApi = createApi({
  reducerPath: 'surveyServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetSurveys: builder.query<any, void>({
      query: (locale) => `survey/?locale=${locale}`,
    }),
    GetSurveyById: builder.query<any, any>({
      query: ({id, locale}) => `survey/${id}?locale=${locale}`,
    }),
    GetSurveyStatsById: builder.query<any, any>({
      query: (id) => `survey/stats/${id}`,
    }),
    PostSurvey: builder.mutation<any, void>({
      query: (body) => ({ url: 'survey/', body: body, method: 'POST' }),
    }),
  }),
});

export const {useLazyGetSurveysQuery, useLazyGetSurveyByIdQuery, usePostSurveyMutation, useLazyGetSurveyStatsByIdQuery} = surveyServiceApi;